import React from 'react';
import QuoteList from './QuoteList';
import '../../styles/Dashboard.css';

const Quotes = () => {
  return (
    <div className="section dashboard-container">
      <div className="columns">
        <div className="column is-12">
          <QuoteList />
        </div>
      </div>
    </div>
  );
};

export default Quotes;
